import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { PorFormularioComponent } from '../actividades/por-formulario/por-formulario.component';

import { SessionTerminarComponent } from '../session/terminar/sessionterminar.component';
import { SessionIniciarComponent } from '../session/iniciar/sessioniniciar.component';


const routes: Routes = [
  { path: '', redirectTo: 'session/iniciar',  pathMatch: 'full'
  },
  {
    path: 'actividades/por-formulario',
    component: PorFormularioComponent
  },
  {
    path: 'session/terminar',
    component: SessionTerminarComponent
  },
  {
    path: 'session/iniciar',
    component: SessionIniciarComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/shared/app-routing.module.ts